export const WILDCARD_SYMBOL = '%';
export const FIO_FILTER_KEY = 'user_data.fio__like:string' as const;
export const WILDCARD_REGEX = new RegExp(`^${WILDCARD_SYMBOL}+|${WILDCARD_SYMBOL}+$`, 'g');
export const appendWildcard = (value: string): string => {
  let $value = value;
  if (!value.startsWith(WILDCARD_SYMBOL)) $value = `%${$value}`;
  if (!value.endsWith(WILDCARD_SYMBOL)) $value = `${$value}%`;
  return $value;
};
export const trimWildcard = (value: string): string => value.replace(WILDCARD_REGEX, '');
